import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'sise-loader',
    templateUrl: './sise-loader.component.html',
    styleUrls: ['./sise-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {'[class.request-active]': 'active'},
    standalone: false
})
export class SiseLoaderComponent {
    @Input() active = false;
    @Input() message = 'Procesando solicitud...';
}
